<div *ngIf="show()" [ngClass]="type" class="message-popup">
  {{ message }}
</div>
